const Dragbar = () => (
  <div aria-hidden className='w-11 h-[3px] mx-auto rounded-[7px] bg-dragbar' />
);

export default Dragbar;
